// UI translations for TR / EN / RU / AR. Easily extendable: add a new lang key.
export const LANGUAGES = [
  { code: "tr", label: "Türkçe", flag: "🇹🇷", dir: "ltr" },
  { code: "en", label: "English", flag: "🇬🇧", dir: "ltr" },
  { code: "ru", label: "Русский", flag: "🇷🇺", dir: "ltr" },
  { code: "ar", label: "العربية", flag: "🇸🇦", dir: "rtl" },
];

export const translations = {
  tr: {
    nav: { experts: "Uzmanlar", categories: "Kategoriler", how: "Nasıl Çalışır", about: "Hakkımızda", login: "Giriş Yap", becomeExpert: "Uzman Ol" },
    hero: {
      badge: "Dünyanın en iyi uzmanları",
      title: "Aradığın uzmanla",
      titleHighlight: "birebir görüş",
      subtitle: "Dünyanın en aranan uzmanlarıyla görüntülü görüşme üzerinden birebir tavsiye al. Kariyerinden yaşam tarzına, hedeflerine ulaşmanın en hızlı yolu.",
      searchPlaceholder: "Uzman, konu veya kategori ara...",
      cta: "Uzmanları Keşfet",
      ctaSecondary: "Nasıl Çalışır?",
      stat1: "Doğrulanmış Uzman", stat2: "Tamamlanan Görüşme", stat3: "Ortalama Puan",
    },
    sections: {
      featured: "Öne Çıkan Uzmanlar", featuredSub: "En çok tercih edilen doğrulanmış uzmanlar",
      categoriesTitle: "Kategoriye Göre Keşfet", categoriesSub: "İlgi alanına uygun uzmanı bul",
      allExperts: "Tüm Uzmanlar", viewAll: "Tümünü Gör",
      results: "Aradığın sonuçları al", resultsSub: "Binlerce insan hedeflerine bizimle ulaştı",
      mission: "Herkese, herkese erişim", missionText: "Misyonumuz herkese herkese erişim sağlamak; birbirimizi güçlendirerek dünyamızı daha iyi bir yer yapmak. Bu erişimi açarak, dünyanın her yerinden daha fazla insan bağlantı kurma, öğrenme ve harekete geçme fırsatına sahip olacak.",
      investors: "Yatırımcılarımız", investorsSub: "Dünyanın önde gelen isimleri bize güveniyor",
      newsletter: "İlk görüşmende 10$ indirim & özel etkinliklere erişim",
      newsletterPlaceholder: "E-posta adresin", newsletterCta: "Katıl",
      newsletterSuccess: "Teşekkürler! Kaydın alındı.",
    },
    expert: {
      session: "Görüşme", book: "Randevu Al", verified: "Doğrulanmış", perSession: "/ görüşme",
      viewProfile: "Profili Gör", about: "Hakkında", expertise: "Uzmanlık Alanları",
      reviews: "Değerlendirme", availability: "Uygunluk", selectDate: "Tarih seç", selectTime: "Saat seç",
      bookNow: "Şimdi Randevu Al", duration: "dakika", close: "Kapat",
      bookingSuccess: "Randevu talebin alındı! Kısa süre içinde onaylanacak.",
    },
    footer: {
      tagline: "Herkese, herkese erişim.",
      company: "Şirket", about: "Hakkımızda", careers: "Kariyer", press: "Basın",
      support: "Destek", help: "Yardım Merkezi", contact: "İletişim", feedback: "Geri Bildirim",
      legal: "Yasal", privacy: "Gizlilik", terms: "Şartlar",
      forExperts: "Uzmanlar İçin", becomeExpert: "Uzman Ol", expertLogin: "Uzman Girişi",
      rights: "Tüm hakları saklıdır.",
    },
    categories: { career: "Kariyer & İş", decor: "Ev Dekorasyonu", beauty: "Stil & Güzellik", wellness: "Wellness & Astroloji" },
    admin: {
      title: "Yönetim Paneli", login: "Yönetici Girişi", username: "Kullanıcı Adı", password: "Şifre",
      signIn: "Giriş Yap", dashboard: "Panel", experts: "Uzmanlar", categories: "Kategoriler",
      investors: "Yatırımcılar", content: "İçerik", settings: "Ayarlar", subscribers: "Aboneler",
      bookings: "Randevular", subscriptions: "Abonelikler", requests: "Talepler", applications: "Başvurular", logout: "Çıkış", save: "Kaydet", add: "Ekle", edit: "Düzenle",
      delete: "Sil", cancel: "İptal",
    },
  },
  en: {
    nav: { experts: "Experts", categories: "Categories", how: "How It Works", about: "About", login: "Log In", becomeExpert: "Become an Expert" },
    hero: {
      badge: "The world's best experts",
      title: "Book a 1-on-1 with the",
      titleHighlight: "expert you need",
      subtitle: "Get personalized advice from the world's most in-demand experts over a video call. The fastest way to reach your goals, from career to lifestyle.",
      searchPlaceholder: "Search experts, topics or categories...",
      cta: "Explore Experts",
      ctaSecondary: "How It Works?",
      stat1: "Verified Experts", stat2: "Completed Sessions", stat3: "Average Rating",
    },
    sections: {
      featured: "Featured Experts", featuredSub: "Our most in-demand verified experts",
      categoriesTitle: "Explore by Category", categoriesSub: "Find the right expert for your interest",
      allExperts: "All Experts", viewAll: "View All",
      results: "Get the results you're looking for", resultsSub: "Thousands have reached their goals with us",
      mission: "Give everyone access to anyone", missionText: "Our mission is to give everyone access to anyone, empowering each other to make our world better. By unlocking this type of access, more people from all over the world will have the same opportunities to connect, learn, and take action.",
      investors: "Our Investors", investorsSub: "Backed by the world's leading names",
      newsletter: "Get $10 off your first session & access to exclusive events",
      newsletterPlaceholder: "Your email address", newsletterCta: "Join",
      newsletterSuccess: "Thank you! Your submission has been received.",
    },
    expert: {
      session: "Session", book: "Book", verified: "Verified", perSession: "/ session",
      viewProfile: "View Profile", about: "About", expertise: "Expertise",
      reviews: "reviews", availability: "Availability", selectDate: "Select date", selectTime: "Select time",
      bookNow: "Book Now", duration: "minutes", close: "Close",
      bookingSuccess: "Your booking request was received! It will be confirmed shortly.",
    },
    footer: {
      tagline: "Give everyone access to anyone.",
      company: "Company", about: "About", careers: "Careers", press: "Press",
      support: "Support", help: "Help Center", contact: "Contact", feedback: "Feedback",
      legal: "Legal", privacy: "Privacy", terms: "Terms",
      forExperts: "For Experts", becomeExpert: "Become an Expert", expertLogin: "Expert Login",
      rights: "All rights reserved.",
    },
    categories: { career: "Career & Business", decor: "Home Decor", beauty: "Style & Beauty", wellness: "Wellness & Astrology" },
    admin: {
      title: "Admin Panel", login: "Admin Login", username: "Username", password: "Password",
      signIn: "Sign In", dashboard: "Dashboard", experts: "Experts", categories: "Categories",
      investors: "Investors", content: "Content", settings: "Settings", subscribers: "Subscribers",
      bookings: "Bookings", subscriptions: "Subscriptions", requests: "Requests", applications: "Applications", logout: "Logout", save: "Save", add: "Add", edit: "Edit",
      delete: "Delete", cancel: "Cancel",
    },
  },
  ru: {
    nav: { experts: "Эксперты", categories: "Категории", how: "Как это работает", about: "О нас", login: "Войти", becomeExpert: "Стать экспертом" },
    hero: {
      badge: "Лучшие эксперты мира",
      title: "Личная встреча с",
      titleHighlight: "нужным экспертом",
      subtitle: "Получите персональный совет от самых востребованных экспертов мира по видеозвонку. Самый быстрый способ достичь целей — от карьеры до образа жизни.",
      searchPlaceholder: "Поиск экспертов, тем или категорий...",
      cta: "Найти экспертов",
      ctaSecondary: "Как это работает?",
      stat1: "Проверенных экспертов", stat2: "Завершённых сессий", stat3: "Средний рейтинг",
    },
    sections: {
      featured: "Рекомендуемые эксперты", featuredSub: "Наши самые востребованные проверенные эксперты",
      categoriesTitle: "По категориям", categoriesSub: "Найдите подходящего эксперта",
      allExperts: "Все эксперты", viewAll: "Смотреть все",
      results: "Достигайте желаемых результатов", resultsSub: "Тысячи людей достигли целей с нами",
      mission: "Доступ каждого к каждому", missionText: "Наша миссия — дать каждому доступ к каждому, чтобы вместе делать мир лучше. Открывая такой доступ, больше людей со всего мира получат равные возможности общаться, учиться и действовать.",
      investors: "Наши инвесторы", investorsSub: "Нам доверяют ведущие имена мира",
      newsletter: "Скидка $10 на первую сессию и доступ к эксклюзивным событиям",
      newsletterPlaceholder: "Ваш email", newsletterCta: "Присоединиться",
      newsletterSuccess: "Спасибо! Ваша заявка получена.",
    },
    expert: {
      session: "Сессия", book: "Записаться", verified: "Проверен", perSession: "/ сессия",
      viewProfile: "Профиль", about: "О себе", expertise: "Экспертиза",
      reviews: "отзывов", availability: "Доступность", selectDate: "Выберите дату", selectTime: "Выберите время",
      bookNow: "Записаться сейчас", duration: "минут", close: "Закрыть",
      bookingSuccess: "Ваша заявка получена! Скоро будет подтверждена.",
    },
    footer: {
      tagline: "Доступ каждого к каждому.",
      company: "Компания", about: "О нас", careers: "Карьера", press: "Пресса",
      support: "Поддержка", help: "Центр помощи", contact: "Контакты", feedback: "Отзывы",
      legal: "Правовая информация", privacy: "Конфиденциальность", terms: "Условия",
      forExperts: "Для экспертов", becomeExpert: "Стать экспертом", expertLogin: "Вход для экспертов",
      rights: "Все права защищены.",
    },
    categories: { career: "Карьера и бизнес", decor: "Домашний декор", beauty: "Стиль и красота", wellness: "Велнес и астрология" },
    admin: {
      title: "Панель управления", login: "Вход администратора", username: "Логин", password: "Пароль",
      signIn: "Войти", dashboard: "Панель", experts: "Эксперты", categories: "Категории",
      investors: "Инвесторы", content: "Контент", settings: "Настройки", subscribers: "Подписчики",
      bookings: "Записи", subscriptions: "Подписки", requests: "Запросы", applications: "Заявки", logout: "Выйти", save: "Сохранить", add: "Добавить", edit: "Изменить",
      delete: "Удалить", cancel: "Отмена",
    },
  },
  ar: {
    nav: { experts: "الخبراء", categories: "الفئات", how: "كيف يعمل", about: "من نحن", login: "تسجيل الدخول", becomeExpert: "كن خبيراً" },
    hero: {
      badge: "أفضل خبراء العالم",
      title: "احجز جلسة خاصة مع",
      titleHighlight: "الخبير الذي تحتاجه",
      subtitle: "احصل على نصائح مخصصة من أكثر الخبراء طلباً في العالم عبر مكالمة فيديو. أسرع طريقة لتحقيق أهدافك، من المهنة إلى نمط الحياة.",
      searchPlaceholder: "ابحث عن خبراء أو مواضيع أو فئات...",
      cta: "استكشف الخبراء",
      ctaSecondary: "كيف يعمل؟",
      stat1: "خبير موثّق", stat2: "جلسة مكتملة", stat3: "متوسط التقييم",
    },
    sections: {
      featured: "الخبراء المميزون", featuredSub: "أكثر خبرائنا الموثوقين طلباً",
      categoriesTitle: "استكشف حسب الفئة", categoriesSub: "اعثر على الخبير المناسب لاهتمامك",
      allExperts: "كل الخبراء", viewAll: "عرض الكل",
      results: "احصل على النتائج التي تبحث عنها", resultsSub: "حقق الآلاف أهدافهم معنا",
      mission: "امنح الجميع الوصول إلى أي شخص", missionText: "مهمتنا هي منح الجميع الوصول إلى أي شخص، وتمكين بعضنا البعض لجعل عالمنا أفضل. من خلال فتح هذا النوع من الوصول، سيحصل المزيد من الناس من جميع أنحاء العالم على نفس الفرص للتواصل والتعلم واتخاذ الإجراءات.",
      investors: "مستثمرونا", investorsSub: "بدعم من أبرز الأسماء العالمية",
      newsletter: "احصل على خصم 10$ على جلستك الأولى ووصول للفعاليات الحصرية",
      newsletterPlaceholder: "بريدك الإلكتروني", newsletterCta: "انضم",
      newsletterSuccess: "شكراً لك! تم استلام طلبك.",
    },
    expert: {
      session: "جلسة", book: "احجز", verified: "موثّق", perSession: "/ جلسة",
      viewProfile: "عرض الملف", about: "نبذة", expertise: "مجالات الخبرة",
      reviews: "تقييم", availability: "التوفر", selectDate: "اختر التاريخ", selectTime: "اختر الوقت",
      bookNow: "احجز الآن", duration: "دقيقة", close: "إغلاق",
      bookingSuccess: "تم استلام طلب الحجز! سيتم تأكيده قريباً.",
    },
    footer: {
      tagline: "امنح الجميع الوصول إلى أي شخص.",
      company: "الشركة", about: "من نحن", careers: "الوظائف", press: "الصحافة",
      support: "الدعم", help: "مركز المساعدة", contact: "اتصل بنا", feedback: "ملاحظات",
      legal: "قانوني", privacy: "الخصوصية", terms: "الشروط",
      forExperts: "للخبراء", becomeExpert: "كن خبيراً", expertLogin: "دخول الخبراء",
      rights: "جميع الحقوق محفوظة.",
    },
    categories: { career: "المهنة والأعمال", decor: "ديكور المنزل", beauty: "الأناقة والجمال", wellness: "العافية والتنجيم" },
    admin: {
      title: "لوحة الإدارة", login: "دخول المسؤول", username: "اسم المستخدم", password: "كلمة المرور",
      signIn: "تسجيل الدخول", dashboard: "لوحة التحكم", experts: "الخبراء", categories: "الفئات",
      investors: "المستثمرون", content: "المحتوى", settings: "الإعدادات", subscribers: "المشتركون",
      bookings: "الحجوزات", subscriptions: "الاشتراكات", requests: "الطلبات الخاصة", applications: "الطلبات", logout: "خروج", save: "حفظ", add: "إضافة", edit: "تعديل",
      delete: "حذف", cancel: "إلغاء",
    },
  },
};
